import { combineReducers } from 'redux';
import types from './types';

const allCollections = (state = [], { type, payload }) => {
  switch (type) {
    case types.getCollectionsSuccess:
      return payload.data;
    default:
      return state;
  }
};

// Entry ids per collection; the entries themselves live in entities.
const entriesByCollection = (state = {}, { type, payload }) => {
  switch (type) {
    case types.getEntriesSuccess:
      return { ...state, [payload.request.collectionId]: payload.data };
    default:
      return state;
  }
};

// The page payload nests categories, entries and attributes per collection and
// is not normalised, so it is kept whole under the page it was fetched for.
const collectionsByPage = (state = {}, { type, payload }) => {
  switch (type) {
    case types.getPageCollectionsSuccess:
      return { ...state, [payload.request.pageId]: payload.data };
    default:
      return state;
  }
};

const collections = combineReducers({
  allCollections,
  entriesByCollection,
  collectionsByPage,
});

export default { collections };
